import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const PlayIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M14.436 6.72 5.408.32C4.354-.48 3 .32 3 1.6v12.8c0 1.28 1.354 2.08 2.408 1.28l9.028-6.4c.752-.64.752-1.92 0-2.56Z", fill: "currentColor" })));
});
PlayIcon.displayName = 'PlayIcon';
export default PlayIcon;
